var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMngo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.21 6.306h-.001c-.582.373-7.672 4.72-11.402-1.803h.001l-.01-.017s6.487-6.647 11.448 1.796l-.038.024zm-9.237 2.197a6.795 6.795 0 0 1-2.03-1.615 8.174 8.174 0 0 0-2.742.418A8.343 8.343 0 0 0 6.65 9.63l.002.004C4.893 11.637 3.968 14.4 4 17.097c.02 1.608.444 3.12 1.14 4.51.078.155.16.31.245.463l-.014.014c.72 1.253 1.66 2.395 2.718 3.402.397.378.817.731 1.258 1.059l.121.09c3.772 2.75 8.222 3.21 8.222 3.21.922.094 1.962.172 3.01.152L20.7 30c2.793-.073 5.717-.87 6.463-3.898.159-.643.179-1.341-.084-1.948-.212-.487-.585-.877-.955-1.264a11.053 11.053 0 0 1-1.306-1.635c-.966-1.49-1.688-3.294-2.181-4.983l-.003.001a15.246 15.246 0 0 1-.096-.333 72.44 72.44 0 0 1-.284-.779c-.32-.884-.636-1.757-1.065-2.582a8.938 8.938 0 0 0-.628-1.039c-.562-.794-1.16-1.568-1.878-2.226-1.237.005-2.53-.203-3.711-.807zm-2.168 17.65a8.113 8.113 0 0 0 1.802-.928 8.52 8.52 0 0 1-1.802.928z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMngo);
export default __webpack_public_path__ + "static/media/MNGO.962ac3e90c0c784a29028428611f4d5b.svg";
export { ForwardRef as ReactComponent };